import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import api from "../../lib/api";

export default function BlogSection() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api
      .get("/posts")
      .then(({ data }) => setPosts(Array.isArray(data) ? data : []))
      .catch(() => setPosts([]));
  }, []);

  return (
    <section id="blog" data-testid="blog-section" className="section-pad relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <div className="overline mb-4">Thoughts & Insights</div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl md:text-6xl leading-none tracking-tight mb-14">
            From The <span className="text-amber">Blog.</span>
          </h2>
        </Reveal>

        {posts.length === 0 ? (
          <p className="text-ink-muted">No posts published yet.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post, i) => (
              <Reveal key={post.id} delay={(i % 3) * 0.08} as="div">
                <Link
                  to={`/blog/${post.slug}`}
                  data-testid={`blog-card-${i}`}
                  className="group text-left w-full h-full rounded-xl border border-white/[0.07] bg-surface p-7 hover:border-amber/30 hover:-translate-y-1 transition-all duration-300 flex flex-col"
                >
                  <span className="self-start rounded-full border border-amber/30 px-3 py-1 text-[0.68rem] uppercase tracking-[0.14em] text-amber">
                    {post.tag}
                  </span>
                  <h3 className="font-display text-xl font-medium mt-5 mb-3 leading-snug">{post.title}</h3>
                  <p className="text-ink-secondary text-[0.92rem] leading-relaxed flex-1">{post.excerpt}</p>
                  <div className="mt-6 flex items-center justify-between text-sm">
                    <span className="text-ink-muted">{post.read_time}</span>
                    <span className="inline-flex items-center gap-1.5 text-amber font-medium">
                      Read <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform duration-300" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
